import axios from 'axios';
import React, { useState } from 'react';

const PostData: React.FC = () => {

    const [ post, setPost ] = useState(null);

    const baseURL = '';
    const data = {
        username: "Alain",
        Title: "1",
        email: "fraternite76-alain@yahoo.fr",
        firstName: "Alain",
        lastName: "Léglise",
        acceptTerms: true,
        password: "BVNBCVNCVNCC",
        passwordConfirmation: "BVNBCVNCVNCC"
    };

    function createPost() {
        axios
            .post(baseURL, data)
            .then((response) => {
                setPost(response.data);
            })
            .catch(err => {
                console.log(err.response.data)
            });
    }

    return (
        <div>
            <button onClick={createPost}>Create Post</button>
        </div>);
}

export default PostData;
